function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.8273 0.458438L14.8355 11.5978H18.0199L20.0132 0.458438H16.8273Z",
  fill: "#1A1F71"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M26.675 0.230713C27.9102 0.230713 28.8993 0.472892 29.5304 0.698569L29.0986 3.11279L28.8132 2.98425C28.2251 2.75857 27.4703 2.54205 26.4286 2.55747C25.1812 2.55747 24.6039 3.05259 24.6039 3.51561C24.5967 4.0374 25.2787 4.38127 26.3923 4.89658C28.2304 5.69169 29.0792 6.65591 29.0673 7.92314C29.0426 10.2355 26.8684 11.7291 23.5194 11.7291C22.0905 11.7151 20.7146 11.4458 19.9704 11.1347L20.4174 8.64114L20.8281 8.81816C21.8745 9.23389 22.5519 9.40273 23.827 9.40273C24.7428 9.40273 25.7252 9.06176 25.7331 8.31503C25.7391 7.82754 25.3223 7.47941 24.0821 6.93325C22.8736 6.40047 21.2727 5.50749 21.2905 3.90687C21.3094 1.74154 23.5268 0.230713 26.675 0.230713Z",
  fill: "#1A1F71"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M35.2672 0.458267H37.729L40.3076 11.5904H37.3513C37.3513 11.5904 37.059 10.3112 36.9637 9.92123C36.7175 9.92123 35.6891 9.91988 34.7223 9.91862C33.8646 9.9175 33.0553 9.91645 32.8834 9.91645C32.7597 10.2179 32.2129 11.5904 32.2129 11.5904H28.8673L33.5989 1.38203C33.9338 0.656631 34.5046 0.458267 35.2672 0.458267ZM33.8231 7.6512H36.4677C36.3402 7.09366 35.7301 4.43464 35.7301 4.43464L35.5148 3.47424C35.4302 3.6944 35.3124 3.98559 35.2226 4.2077C35.1418 4.40754 35.0836 4.55145 35.0924 4.53741C35.0924 4.53741 34.0868 7.00912 33.8231 7.6512Z",
  fill: "#1A1F71"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M9.0117 8.05481L12.1308 0.458267L15.5058 0.458154L10.49 11.5764L7.11917 11.58L4.29214 1.9239C3.30741 1.40086 2.18237 0.980687 0.923096 0.690177L0.963817 0.458412H6.10122C6.79319 0.482994 7.35266 0.693819 7.54546 1.39919L8.62913 6.36503C8.64679 6.41381 8.66356 6.46251 8.67942 6.51109L9.0117 8.05481Z",
  fill: "#1A1F71"
});
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 12,
    viewBox: "0 0 41 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.55f26694.svg";
export { ForwardRef as ReactComponent };